import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import { MultiImageBlock } from '../Image/MultiImageBlock';
import Button from '../Button';
import ReactGoogleAutocomplete from '../InputFields/GoogleMapsAddressField';
import TwoGroup from '../TwoGroup';

import { copyFor, capitalization } from '../../copy/copy';

const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top: 0.75em;

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            ${props => (props.submitting ? `text-indent: -99999px;` : '')};
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            display: none;
            top: 7px;
            right: 25%;
            margin-right: -16px;
            width: 32px !important;
            height: 32px !important;

            ${props => (props.submitting ? `display: block` : '')};
        }
    }
`;

const FindRepFormContainer = styled.form`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const FormGroup = styled.div``;

const PopupTitle = styled.span`
    font-family: Averta;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.38;
    max-width: 90%;
`;

const PopupHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
`;

const Close = styled.div`
    transform: rotate(45deg);
    font-family: Averta;
    font-size: 1.5em;
    line-height: 0.8;
    text-align: left;
    color: #5d656c;
    display: inline;
    cursor: pointer;
    max-height: 1em;
    position: absolute;
    top: -15px;
    right: -10px;
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 18px;

    span {
        margin-left: 20px;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        line-height: 1.33;
        max-width: 60%;
    }
`;

class FindRepForm extends React.Component {
    constructor() {
        super();
        this.state = {
            valid: false
        };
    }

    setValidState(bool) {
        this.setState({ valid: bool });
    }
    render() {
        return (
            <FindRepFormContainer onSubmit={this.props.handleSubmit} autocomplete="on">
                {this.props.isDoubleCheckRepPopup && (
                    <div>
                        <PopupHeader>
                            <PopupTitle>
                                {copyFor('findReps', 'confirmRep', undefined, undefined)}
                            </PopupTitle>
                            <Close onClick={() => this.props.onBack()}>+</Close>
                        </PopupHeader>
                        <Row>
                            <MultiImageBlock
                                isLocalRepLoading={this.props.isLocalRepLoading}
                                imgSources={this.props.imgSources}
                            />
                            <span>{this.props.formattedReps}</span>
                        </Row>
                    </div>
                )}
                {!this.props.isDoubleCheckRepPopup && (
                    <FormGroup>
                        <ReactGoogleAutocomplete
                            formName={['google_autocomplete']}
                            fields={['address_components', 'formatted_address']}
                            types={['address']}
                            typeToReturn={'string'}
                            componentRestrictions={{ country: 'US' }}
                            setValidState={this.setValidState.bind(this)}
                        />
                    </FormGroup>
                )}
                <ButtonGroup submitting={this.props.submitting}>
                    <TwoGroup>
                        <Button
                            style={
                                this.props.isDoubleCheckRepPopup
                                    ? { visibility: 'hidden' }
                                    : {}
                            }
                            label={copyFor(
                                'buttons',
                                'back',
                                undefined,
                                capitalization.eachWord
                            )}
                            onClick={this.props.onBack}
                        />
                        <Button
                            primary={true}
                            label={
                                this.props.isDoubleCheckRepPopup
                                    ? copyFor(
                                          'buttons',
                                          'send',
                                          'email',
                                          capitalization.eachWord
                                      )
                                    : copyFor(
                                          'buttons',
                                          'submit',
                                          undefined,
                                          capitalization.eachWord
                                      )
                            }
                            type="submit"
                            className="submitButton"
                            disabled={
                                this.props.isDoubleCheckRepPopup
                                    ? false
                                    : !this.state.valid
                            }
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </FindRepFormContainer>
        );
    }
}

FindRepForm.propTypes = {
    formattedReps: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    imgSources: PropTypes.arrayOf(PropTypes.string).isRequired,
    isDoubleCheckRepPopup: PropTypes.bool,
    isLocalRepLoading: PropTypes.bool.isRequired,
    onBack: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};

export default FindRepForm;
